/** @jsx jsx */
import { jsx, Box, Close } from 'theme-ui'
import Paragraph from '../Typography/Paragraph/Paragraph'

const checkClose = close => {
  return (
    close && (
      <Close
        sx={
          {
            // margin: '7.33px',
            // marginLeft: '0px',
          }
        }
      />
    )
  )
}

const CustomTag = ({
  text,
  close,
  variant = 'captionSemiBold',
  bodyVariant = 'tag',
  paragraphProps,
  ...props
}) => {
  return (
    <Box variant={bodyVariant} {...props}>
      <Paragraph
        variant={variant}
        sx={{
          padding: 0,
          textTransform: 'uppercase',
          fontSize: 10,
          lineHeight: '10px',
        }}
        {...paragraphProps}
      >
        {text}
      </Paragraph>
      {checkClose(close)}
    </Box>
  )
}

export default CustomTag
